import { globalVars } from "../../globalVariables";
export const checkGCSpawn = () => {
    globalVars.natGCOnScreen = Game.shimmers.some((shimmer) => shimmer.type === "golden" && shimmer.spawnLead);
};
